var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExteriorEntertainingLounge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90295 15.629V12.5806M15.7138 15.629V12.5806M7.90295 12.5806V10.3955C7.90295 9.19721 6.93155 8.22581 5.73326 8.22581V8.22581M7.90295 12.5806H15.7138M15.7138 12.5806V10.1062C15.7138 9.06769 16.5557 8.22581 17.5942 8.22581V8.22581M5.73326 8.22581H2.83871C1.82322 8.22581 1 9.04903 1 10.0645V10.8241C1 11.4201 1.48316 11.9032 2.07917 11.9032V11.9032C2.67518 11.9032 3.15835 12.3864 3.15835 12.9824V15.9599C3.15835 17.7814 4.63498 19.2581 6.45649 19.2581V19.2581M5.73326 8.22581V8.22581C5.73326 5.33967 8.07294 3 10.9591 3H12.3684C15.2546 3 17.5942 5.33967 17.5942 8.22581V8.22581M17.5942 8.22581H20.1613C21.1768 8.22581 22 9.04902 22 10.0645V10.9878C22 11.4934 21.5902 11.9032 21.0846 11.9032V11.9032C20.579 11.9032 20.1692 12.3131 20.1692 12.8186V16.1046C20.1692 17.8462 18.7573 19.2581 17.0156 19.2581V19.2581M6.45649 19.2581V19.9684C6.45649 20.5381 6.91837 21 7.48812 21V21C8.05787 21 8.51975 20.5381 8.51975 19.9684V19.2581M6.45649 19.2581H8.51975M8.51975 19.2581H15.097M17.0156 19.2581V20.0407C17.0156 20.5705 16.5862 21 16.0563 21V21C15.5265 21 15.097 20.5705 15.097 20.0407V19.2581M17.0156 19.2581H15.097",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExteriorEntertainingLounge);
export default __webpack_public_path__ + "static/media/exterior_entertaining_lounge.35225c8c1cb26bced83bd36d56320fd4.svg";
export { ForwardRef as ReactComponent };